import { render, staticRenderFns } from "./OtheHeader.vue?vue&type=template&id=4fd34337&scoped=true&"
import script from "./OtheHeader.vue?vue&type=script&lang=js&"
export * from "./OtheHeader.vue?vue&type=script&lang=js&"
import style0 from "./OtheHeader.vue?vue&type=style&index=0&id=4fd34337&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fd34337",
  null
  
)

export default component.exports